import gql from "graphql-tag";
import { productSpecGroupFragment } from "../fragments/productSpecGroup";

export default gql`
  mutation addProductSpecGroupMutation($input: AddProductSpecGroupInput!) {
    addProductSpecGroup(input: $input) {
      productSpecGroup {
        ...ProductSpecGroup
      }
    }
  }
  ${productSpecGroupFragment}
`;
